import { Container, Heading4, ImageLite, Paragraph } from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";

import styles from "./Content085.module.scss";
import { LeftBlock } from "./LeftBlock";
import { RightBlock } from "./RightBlock";

export const Content085 = ({ payload }) => {
  const { isDesktop } = useViewMode();
  const image = payload?.leftImage ?? {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.blocks}>
          <ImageLite image={image} className={styles.image}></ImageLite>
          {isDesktop && <LeftBlock {...payload}></LeftBlock>}
          <RightBlock {...payload}></RightBlock>
        </div>
      </Container>
    </div>
  );
};

export default Content085;
